import { useContext, createContext } from 'react';

type DisplayConfigProps = {
  highlightedSeriesIds?: string[];
};

export const DisplayConfigContext = createContext<DisplayConfigProps>({});

export function useDisplayConfigContext(): DisplayConfigProps {
  return useContext(DisplayConfigContext);
}

DisplayConfigContext['displayName'] = 'DisplayConfigContext';
